import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

let NO_MIGRATION_WHITELIST = ['4f52e']

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let xid = useDataValue({
    context: 'global',
    path: 'current_location.xid',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    // some pcs will have had nothing they wanted to migrate so just leave them with an empty scenario
    if (NO_MIGRATION_WHITELIST.includes(xid)) return [true]

    if (!data) return data
    return !(
      data.tasks_boards.length === 0 && data.vaxiom_task_baskets.length > 0
    )
      ? [true]
      : []
  }, [data])
}
